import { useEffect, useState } from "react";

/**
 * Полоска «пройдите обучение — два месяца в подарок».
 *
 * Обучение — лучшее, что есть у доски для новичка, но кнопку «Обучение ✨»
 * в шапке замечают не все: человек открывает доску, видит пустое поле и
 * уходит пробовать наугад. Полоска говорит об этом прямо и закрывается
 * навсегда одним нажатием — надоедать ею нельзя.
 */

/** Закрыли насовсем. Снести можно только очисткой хранилища. */
const HIDE_KEY = "wb-board-tour-promo-hidden";

/** Обучение уже пройдено — звать второй раз незачем. */
const DONE_KEY = "wb-board-tour-done";

function flagSet(key: string): boolean {
  try {
    return window.localStorage.getItem(key) === "1";
  } catch {
    // Приватный режим — полоску покажем, это не страшно.
    return false;
  }
}

type Props = {
  /** Только хозяину доски на бесплатном тарифе. */
  visible?: boolean;
  onStart: () => void;
};

export function BoardTourPromoStrip({ visible = true, onStart }: Props) {
  const [hidden, setHidden] = useState(() => flagSet(HIDE_KEY) || flagSet(DONE_KEY));

  useEffect(() => {
    // Обучение закончили прямо сейчас — полоска уходит, не дожидаясь
    // перезагрузки страницы.
    function onDone() {
      setHidden(true);
    }
    window.addEventListener("wb-tour-done", onDone);
    return () => window.removeEventListener("wb-tour-done", onDone);
  }, []);

  if (!visible || hidden) return null;

  return (
    <aside className="wb-board-tour-promo" aria-label="Приглашение пройти обучение">
      <div className="wb-board-tour-promo__inner">
        <span className="wb-board-tour-promo__text">
          <b>Пройдите обучение и получите 2 месяца подписки бесплатно!</b>
          <span className="wb-board-tour-promo__sub">
            Пятнадцать минут — и доска перестаёт быть незнакомой.
          </span>
        </span>
        <div className="wb-board-tour-promo__actions">
          <button type="button" className="wb-board-tour-promo__cta" onClick={onStart}>
            Пройти обучение
          </button>
          <button
            type="button"
            className="wb-board-tour-promo__dismiss"
            title="Больше не показывать"
            aria-label="Больше не показывать"
            onClick={() => {
              try {
                window.localStorage.setItem(HIDE_KEY, "1");
              } catch {
                /* не запомнилось — вернётся при следующем открытии */
              }
              setHidden(true);
            }}
          >
            ×
          </button>
        </div>
      </div>
    </aside>
  );
}
